import * as React from 'react';
import * as style from './style.sass';
import { GroupBox, Button, Input } from 'arbina-ui';

interface Properties {
  onSignIn: (login: string, password: string) => Promise<any>;
}

interface State {
  login: string;
  password: string;
}

export class SignIn extends React.Component<Properties> {
  state: State = {
    login: '',
    password: '',
  };

  onLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({
    login: event.target.value,
  })

  onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({
    password: event.target.value,
  })

  onSignIn = async () => {
    const { login, password } = this.state;
    await this.props.onSignIn(login, password);
  }

  onInputKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { login, password } = this.state;

    if (event.keyCode === 13 && !!login && !!password) {
      await this.onSignIn();
    }
  }

  render() {
    const { login, password } = this.state;

    return (<div className={style.signIn}>
      <GroupBox
        title="Who are you?"
      >
        <div className={style.content}>
          <Input
            autoFocus
            hint="Username"
            value={login}
            onChange={this.onLoginChange}
            onKeyDown={this.onInputKeyDown}
          />
          <Input
            type="password"
            hint="Password"
            value={password}
            onChange={this.onPasswordChange}
            onKeyDown={this.onInputKeyDown}
          />
          <Button
            disabled={!login || !password}
            primary
            text="Sign in"
            onClick={this.onSignIn}
          />
        </div>
      </GroupBox>
    </div>);
  }
}
